module.exports = __webpack_public_path__ + "media/images/form-status-revision-completed-5072f04b.gif";